import React from "react";
import {Route, Routes} from 'react-router';
import { BrowserRouter } from "react-router-dom";
import WallPage from "./WallPage";
import IntroPage from "./IntroPage";
import AnimationLayout from "./AnimationLayout";
import SetViewType from "./SetViewType";
import CoCurricularWall from "./CoCurricularWallPage";

const Router:React.FC = () => {
  return (
    <BrowserRouter>
      <SetViewType>
        <Routes>
          <Route element={<AnimationLayout />}>
            <Route path={'/curriculum'} element={<IntroPage />} />
            <Route path={'/curriculum/subjects'} element={<WallPage />} />
            <Route path={'/curriculum/specialist-modules'} element={<WallPage />} />
            <Route path={'/curriculum/co-curricular'} element={<CoCurricularWall /> } />
          </Route>
        </Routes>
      </SetViewType>
    </BrowserRouter>
  )
}

export default Router;
